<template>
  <div>
    <div>
      <!-- <v-breadcrumbs :items="items" class="breadcrumb">

      </v-breadcrumbs> -->
    </div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-card v-if="ay_std_div_list != null" class="box">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong>HomeWork Report </strong>
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-row justify="center" dense>
          <v-col sm="2">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
              :items="ay_std_div_list" item-text="ay" label="Academic Year" outlined @change="getStd()" persistent-hint
              hint="Select Academic Year " />
          </v-col>
          <v-col sm="2" v-if="std_div_list != null">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
              :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv" persistent-hint
              hint="Select Standard " />
          </v-col>
          <v-col sm="2" v-if="div_list != null">
            <v-icon color="error">*</v-icon>
            <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
              item-text="div_name" label="Division" outlined persistent-hint hint="Select Division" />
          </v-col>
          <v-col sm="2" v-if="sel_ay_data && sel_std_data">
            <v-btn class="mt-6 button" color="primary" @click="get_homework_report"
              :loading="fetch_btn_load">Fetch</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
      <v-data-table :headers="headers" :items="homework_list1" :search="search" class="mytable" id="my-table-id"
        no-data-text="No records match selected filters">
        <template v-slot:item.attachment="{ item }">
          <span style="color: grey" v-if="item.attachment == '-'">--</span>
          <div v-else>
            <v-icon @click="get_hw_attachment_list(item)">mdi mdi-file</v-icon>
          </div>

        </template>
        <template v-slot:item.is_assignment="{ item }">
          <span v-if="item.is_assignment">
            <v-icon class="mr-2 v-icon-size" color="success">mdi-alpha-a-circle</v-icon>
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error">mdi-alpha-m-circle</v-icon>
          </span>
        </template>
        <template v-slot:item.action="{ item }">
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon v-bind="attrs" v-on="on" @click="view_more(item)">
                <v-icon>mdi-dots-horizontal</v-icon></v-btn>
            </template>
            <span> View More </span>
          </v-tooltip>
        </template>
        <template v-slot:top class="pb-5">
          <v-toolbar dense class="toolbar" flat color="white">
            <v-btn rounded small color="white" outlined @click="fnExcelReport('my-table-id', 'Homework Report')"><v-icon
                color="white">mdi-export</v-icon>Export</v-btn>
            <v-divider class="mx-4 mr-10" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field class="" v-model="search" background-color="white" append-icon="mdi-magnify" label="Search"
              single-line hide-details></v-text-field>
          </v-toolbar>
          <v-row justify="center" align="center" v-if="homework_list.length > 0">

            <v-col cols="12" md="3">
              <v-autocomplete hide-details dense outlined multiple clearable label="Course Name"
                :items="columnValueList('course_name')" v-model="filters.course_name" />
            </v-col>

            <v-col cols="12" md="3">
              <v-autocomplete hide-details dense outlined multiple clearable label="Faculty Name"
                :items="columnValueList('faculty_name')" v-model="filters.faculty_name" />
            </v-col>

            <v-col cols="12" md="3">
              <v-autocomplete hide-details dense outlined multiple clearable label="Month" :items="monthList"
                v-model="filters.month" />
            </v-col>

          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog">
      <v-card>
        <v-card-title class="ml-6 mb-n1">
          <v-spacer></v-spacer>
          Course Name-
          <span style="color: indigo">
            <strong>
              {{ dialogItem.course_name }}
            </strong>
          </span>
          <v-divider class="mx-4" inset vertical></v-divider>
          Course Instructor:-
          <span style="color: indigo">
            <strong>
              {{ dialogItem.faculty_name }}
            </strong>
          </span>
          <v-spacer></v-spacer>
        </v-card-title>
        <hr color="indigo" />
        <v-card-text>
          <v-container class="mt-n6">
            <v-list-item three-line>
              <v-list-item-content>
                <v-list-item-title class="mb-1">
                  Title:- <strong> {{ dialogItem.title }}</strong>
                </v-list-item-title>
                <v-list-item-title class="mb-1">
                  Assigned Date:-
                  <strong> {{ dialogItem.assigned_date }}</strong>
                </v-list-item-title>
                <!-- <v-list-item-title class="mb-1">
                  Due Date:- <strong> {{ dialogItem.due_date }}</strong>
                </v-list-item-title> -->
                <v-list-item-title class="mb-1">
                  Attachments:-
                  <a target="_blank" v-bind:href="basepath + dialogItem.attachment" v-if="dialogItem.attachment != '-'">
                    <strong> Attachment </strong>
                  </a>
                  <span style="color: grey" v-if="dialogItem.attachment == null">
                    <strong>--</strong>
                  </span>
                </v-list-item-title>
                <v-list-item-title class="mb-1">
                  Description:
                  <strong>
                    <v-textarea outlined v-model="dialogItem.description" readonly></v-textarea></strong>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn class="mt-6 button" @click="close">Close</v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="attachment_dialog" width="300">
      <v-card>

        <v-card-text>
          <v-simple-table>
            <thead>
              <tr>
                <th>Attachemnt</th>
                <th>Model Answer</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in hw_attachment_list">
                <td>
                  <center v-if="item.attachment != '-'"> <a target="_blank" :href="basepath + item.attachment"><v-icon>mdi
                        mdi-eye</v-icon></a></center>
                  <center v-else>
                    <div></div>
                  </center>
                </td>
                <td>
                  <center v-if="item.model_answer != '-'"> <a target="_blank"
                      :href="basepath + item.model_answer"><v-icon>mdi
                        mdi-eye</v-icon></a></center>
                  <center v-else>
                    <div></div>
                  </center>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard

export default {
  data: () => ({
    fetch_btn_load: false,
    overlay: false,
    search: "",
    snackbar: false,
    items: [
      { text: "Home", disabled: false, href: "/home-updated" },
      { text: "Home Work Report", disabled: true, href: "" },
    ],

    snackbar_msg: "",
    color: "",
    ay_std_div_list: null,
    sel_std_data: null,
    div_list: null,
    std_div_list: null,
    homework_list: [],
    basepath: null,
    headers: [
      {
        text: "Sr. No.",
        value: "srno",
        align: "center",
      },
      {
        text: "Title",
        value: "title",
        align: "center",
      },
      {
        text: "Course Name",
        value: "course_name",
        align: "center",
      },
      {
        text: "Faculty Name",
        value: "faculty_name",
        align: "center",
      },
      {
        text: "Attachment",
        value: "attachment",
        align: "center",
      },
      {
        text: "Assignment / Material ?",
        value: "is_assignment",
        align: "center",
      },
      {
        text: "Assigned Date",
        value: "assigned_date",
        align: "center",
      },
      {
        text: "Due Date",
        value: "due_date",
        align: "center",
      },
      {
        text: "View More",
        value: "action",
        align: "center",
      },
    ],
    dialogItem: {
      title: "",
      description: "",
      due_date: "",
      assigned_date: "",
      marks: "",
      course_name: "",
      faculty_name: "",
      is_assignment: "",
      total_students: "",
      total_submissions: "",
      total_evaluations: "",
      attachment: "",
    },

    attachment_dialog: false,
    hw_attachment_list: [],
    get_hw_attachment_list_loader: false,

    dialog: false,
    filters: {
      course_name: [],
      faculty_name: [],
      month: [],
    },
  }),
  computed: {
    homework_list1() {
      let sortedList = [...this.homework_list].sort((a, b) => {
        return new Date(b.assigned_date) - new Date(a.assigned_date);
      });

      return sortedList.filter(d =>
        (this.filters.course_name.length === 0 ||
          this.filters.course_name.includes(d.course_name)) &&

        (this.filters.faculty_name.length === 0 ||
          this.filters.faculty_name.includes(d.faculty_name)) &&

        (this.filters.month.length === 0 ||
          this.filters.month.includes(d.month))
      );
    },
    monthList() {
      return [...new Set(this.homework_list.map(item => item.month))];
    },
  },
  mounted() {
    this.get_ay_std();
    this.basepath = localStorage.getItem("awspath");
  },
  methods: {
    get_hw_attachment_list(item) {

      const data = {
        homework_id: item.homework_id
      };
      this.get_hw_attachment_list_loader = true
      axios
        .post("/Homework/get_hw_attachment_list", data)
        .then(res => {
          if (res.data.msg == "200") {
            this.hw_attachment_list = res.data.hw_attachment_list;
            this.get_hw_attachment_list_loader = false;
            this.attachment_dialog = true;
          } else {
            this.showSnackbar("#b71c1c", res.data.msg); // show snackbar
          }
        })
    },
    fnExcelReport(id, name) {
      let tab_text = `<table border='1px'>
            <tr>
            <th>Sr. No.</th>
            <th>Title</th>
            <th>Course Name</th>
            <th>Faculty Name</th>
            <th>Attachment</th>
            <th>Assignment / Material ?</th>
            <th>Assigned Date</th>
            <th>Due Date</th>
            </tr>`;

      this.homework_list1.forEach((s) => {
        let is_assignment = s.is_assignment ? "A" : "M";
        let attachmentLink = s.attachment != '-'
          ? `<a href="${this.basepath + s.attachment}" target="_blank">Attachment</a>`
          : "--";
        tab_text += `
            <tr>
                <td>${s.srno}</td>
                <td>${s.title}</td>
                <td>${s.course_name}</td>
                <td>${s.faculty_name}</td>
                <td>${attachmentLink}</td>
                <td>${is_assignment}</td>
                <td>${s.assigned_date}</td>
                <td>${s.due_date}</td>
            </tr>`;
      });

      tab_text += "</table>";

      const blob = new Blob([tab_text], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const filename = name + ".xls";

      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        // For IE
        window.navigator.msSaveOrOpenBlob(blob, filename);
      } else {
        // For modern browsers
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
      }
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    get_ay_std() {
      this.overlay = true;
      //api-1
      axios
        .post("/CommonAPI/get_ay_std_div_for_report_by_access")
        .then((res) => {
          this.overlay = false;
          this.ay_std_div_list = res.data.data;
          this.sel_ay_data = res.data.curr_ay;
        })
        .catch((error) => {
          this.overlay = false;
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
          //close loader
        });
    },
    getStd() {
      this.std_div_list = ["All"];
      this.sel_std_data = "All";
      this.div_list = null;
      this.div = null;
      this.std_div_list = this.sel_ay_data.std_list;
      this.std_div_list.unshift("All");
    },
    getDiv() {
      this.div_list = ["All"];
      this.div = "All";
      this.div_list = this.sel_std_data.div_list;
      this.div_list.unshift("All");
      this.div = this.div_list[0];
      if (this.div_list.length == 0) {
        alert("No division found!!!");
        this.div_list = null;
      }
    },
    get_homework_report() {
      this.homework_list = [];
      this.filters = {
        course_name: [],
        faculty_name: [],
        month: []
      };

      let div;
      if (this.div != null) {
        div = this.div.div_off_id;
        if (this.div.div_off_id) {
          div = this.div.div_off_id;
        } else {
          div = this.div;
        }
      }
      let ay;
      if (this.sel_ay_data.ay_id) {
        ay = this.sel_ay_data.ay_id;
      } else if (this.sel_ay_data.id) {
        ay = this.sel_ay_data.id;
      }
      let data = {
        current_academic_year_id: ay,
        standard_obj: this.sel_std_data,
        division_off_id: div,
      };
      this.overlay = true;
      axios
        .post("/Homework/homework_report", data)
        .then((res) => {
          // this.overlay = false;
          if (res.data.msg == "200") {
            // this.homework_list = res.data.homework_list;
            // console.log(res.data.homework_list.length);
            if (res.data.homework_list.length == 0) {
              this.showSnackbar("#b71c1c", "No Data Found!");
              this.homework_list = [];
            } else {
              this.homework_list = res.data.homework_list.map(item => {
                let date = new Date(item.assigned_date);

                return {
                  ...item,
                  month: date.toLocaleString('default', { month: 'long' }) // June, July, etc.
                };
              });
            }
          } else {
            this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
            //error
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.overlay = false;
          this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
          window.console.log(error);
        })
        .finally(() => {
          this.overlay = false;
          //close loader
          this.fetch_btn_load = false;
        });
    },
    view_more(item) {
      // console.log("insinde view_more");
      // console.log(item);
      this.dialogItem = Object.assign({}, item);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    columnValueList(val) {
      return [...new Set(this.homework_list.map(d => d[val]))];
    },
  },
};
</script>

<style scoped>
.breadcrumb {
  padding: 10px;

  margin-left: 80px;
  margin-top: -50px;
  font-size: medium;
  font-weight: bold;
}
</style>